import { render, staticRenderFns } from "./CustomerLedgerDownloadReport.vue?vue&type=template&id=90061fc8&"
import script from "./CustomerLedgerDownloadReport.vue?vue&type=script&lang=js&"
export * from "./CustomerLedgerDownloadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports